
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"134","viewBox":"0 0 100 134"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"logo-mark__layer-1",attrs:{"d":"M9 113.7v16c0 2.4 2 4.3 4.3 4.3h73.5c2.3 0 4.3-2 4.3-4.3v-13.2c0-1-.8-1.9-1.8-1.9L11 111.8c-1.1 0-2 .8-2 1.9"}}),_c('path',{staticClass:"logo-mark__layer-2",attrs:{"d":"M16.2 95.7v7.9c0 1 .8 1.9 1.8 1.9l78.2 2.8c1 0 2-.8 2-1.9v-12c0-1-.8-1.9-2-1.9L18 93.9c-1.1-.1-1.8.7-1.8 1.8"}}),_c('path',{staticClass:"logo-mark__layer-3",attrs:{"d":"M1.8 73.5v12.1c0 1 .8 1.9 2 1.9l78.3-1.3c1 0 1.9-.8 1.9-1.9v-7.9c0-1-.8-1.9-1.8-1.9L3.8 71.6c-1.1 0-2 .8-2 1.9"}}),_c('path',{staticClass:"logo-mark__layer-4",attrs:{"d":"M16.2 54.7v8.6c0 1 .8 1.9 1.8 1.9L96.2 68c1 0 2-.8 2-1.9V53.5c0-1-.8-1.9-2-1.9L18 52.9c-1.1-.1-1.8.8-1.8 1.8"}}),_c('path',{staticClass:"logo-mark__layer-5",attrs:{"d":"M97.5 33.3l-43.6-32c-2.3-1.8-5.4-1.8-7.8 0L25.8 17.2v-3.7c0-2.4-2-4.3-4.3-4.3h-8.2c-2.3 0-4.3 2-4.3 4.3v16.7l-6.5 5C-2.3 38.9.3 46.6 6.4 46.6l87.2-1.9c6.1 0 8.7-7.7 3.9-11.4"}})])
          )
        }
      }
    